export class Activity {
    _id : string; 
    title: string;
    distance: number;
    duration: number;
    dateTime: string;
    active :boolean;
    type : string;
    dateTimeCreation: Date;
    displayRemove : boolean
}